"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetBucketNotificationInput = {
    type: "structure",
    required: ["Bucket"],
    members: {
        Bucket: {
            shape: {
                type: "string"
            },
            location: "uri",
            locationName: "Bucket"
        }
    }
};
//# sourceMappingURL=GetBucketNotificationInput.js.map